import * as React from "react";
import PropTypes from "prop-types";
import { Switch } from "../../../../themeV2";

export default function ToggleSwitch({ checked, onChange, error, helperText }) {
  const handleChange = React.useCallback(
    (newValue) => {
      onChange(null, newValue);
    },
    [onChange],
  );

  return (
    <div>
      <Switch
        checked={checked}
        onCheckedChange={handleChange}
        label="Group Shop"
      />
      {error && helperText && (
        <p
          style={{
            font: "var(--type-body-md)",
            letterSpacing: "var(--tracking-body-md)",
            color: "var(--md-error)",
            margin: "var(--space-1) 0 0",
          }}
        >
          {helperText}
        </p>
      )}
    </div>
  );
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};
